import { ulid } from 'ulid';

export const newId = () => ulid();
